import AskUsAnything from './AskUsAnything';

interface AssistantRendererProps {
  product: string;
  showAskUsAnything?: boolean;
  page: string;
}

/**
 * AssistantRenderer Checks if Assistant button will be displayed
 *
 * @param showAskUsAnything - Hides Assistant button element
 */
export const AssistantRenderer = ({ product, page }: AssistantRendererProps): JSX.Element | null => {
  return <AskUsAnything product={product} page={page} />;
};
